"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeChart = exports.getRangeDataset = exports.getRangesFromData = exports.nameColors = exports.sourceAttribute = void 0;
var Highcharts = __importStar(require("highcharts"));
var exporting_1 = __importDefault(require("highcharts/modules/exporting"));
var export_data_1 = __importDefault(require("highcharts/modules/export-data"));
var series_label_1 = __importDefault(require("highcharts/modules/series-label"));
var chart_config_1 = require("./chart-config");
// @ts-expect-error: no TS here
var date_range_chart_1 = require("../../timeline/date-range-chart");
var accessibility_1 = __importDefault(require("highcharts/modules/accessibility"));
var utils_1 = require("./utils");
var timeline_chart_1 = require("./timeline-chart");
(0, exporting_1.default)(Highcharts);
(0, export_data_1.default)(Highcharts);
(0, series_label_1.default)(Highcharts);
(0, accessibility_1.default)(Highcharts);
var createLabels = function (rangeData, range) {
    return (0, utils_1.filterPoints)(rangeData, range).map(function (point) { return new Date(point.month); });
};
var createPriceDataset = function (label, color) {
    return {
        data: [],
        label: label,
        steppedLine: 'before',
        fill: false,
        spanGaps: true,
        lineColor: color,
        backgroundColor: '#fff',
        borderWidth: 2,
        pointBorderWidth: 2,
        pointHitRadius: 6,
    };
};
exports.sourceAttribute = {
    hasScau: { name: 'SCAU', code: 'hasScau', color: chart_config_1.brightTurquoise[2] },
    hasScup: { name: 'SCUP', code: 'hasScup', color: chart_config_1.casablanca[2] },
    hasDncDou: { name: 'Dnc/DoÚ', code: 'hasDncDou', color: chart_config_1.cranberry[1] },
    hasPositiveListVzp: { name: 'Pozitivní list VZP', code: 'hasPositiveListVzp', color: chart_config_1.lavenderRose[1] },
    hasPositiveListSzp: { name: 'Pozitivní list SZP', code: 'hasPositiveListSzp', color: chart_config_1.havelockBlue[1] },
    hasNhvlp: { name: 'NHVLP', code: 'hasNhvlp', color: chart_config_1.portGore[2] },
    hasDis13: { name: 'DIS-13', code: 'hasDis13', color: chart_config_1.geraldine[2] },
    hasLek13: { name: 'LEK-13', code: 'hasLek13', color: chart_config_1.emerald[2] },
};
var valConfig = {
    mcv: {
        name: 'Cena původce [SCAU/SCUP]',
        color: chart_config_1.lineChartColors[0],
        colorSource: exports.sourceAttribute.hasScau.color,
    },
    mfc: {
        name: 'Konečná cena s maximální OP a DPH [SCAU]',
        color: chart_config_1.lineChartColors[1],
        colorSource: exports.sourceAttribute.hasScau.color,
    },
    nhvlpMfc: {
        name: 'Konečná cena s maximální OP a DPH [NHVLP]',
        color: chart_config_1.lineChartColors[2],
        colorSource: exports.sourceAttribute.hasNhvlp.color,
    },
    exFactory: { name: 'Ex-F [DIS-13]', color: chart_config_1.lineChartColors[3], colorSource: exports.sourceAttribute.hasDis13.color },
    maxRetailPrice: {
        name: 'Maximální dopočítaná cena [DIS-13]',
        color: chart_config_1.lineChartColors[4],
        colorSource: exports.sourceAttribute.hasDis13.color,
    },
    uhr1: { name: 'Úhrada [SCAU]', color: chart_config_1.lineChartColors[5], colorSource: exports.sourceAttribute.hasScau.color },
    nhvlpUhr1: { name: 'Úhrada [NHVLP]', color: chart_config_1.lineChartColors[6], colorSource: exports.sourceAttribute.hasNhvlp.color },
    juhr1: { name: 'Jádrová úhrada [SCAU]', color: chart_config_1.lineChartColors[7], colorSource: exports.sourceAttribute.hasScau.color },
    ekv1: {
        name: 'Základní úhrada za ODTD1 [SCAU]',
        color: chart_config_1.lineChartColors[8],
        colorSource: exports.sourceAttribute.hasScau.color,
    },
    uhr2: { name: 'Druhá úhrada [SCAU]', color: chart_config_1.lineChartColors[9], colorSource: exports.sourceAttribute.hasScau.color },
    uhr3: { name: 'Třetí úhrada [SCAU]', color: chart_config_1.lineChartColors[10], colorSource: exports.sourceAttribute.hasScau.color },
    uhr4: { name: 'Čtvrtá úhrada [SCAU]', color: chart_config_1.lineChartColors[11], colorSource: exports.sourceAttribute.hasScau.color },
    uhr5: { name: 'Pátá úhrada [SCAU]', color: chart_config_1.lineChartColors[12], colorSource: exports.sourceAttribute.hasScau.color },
    uhr6: { name: 'Šestá úhrada [SCAU]', color: chart_config_1.lineChartColors[13], colorSource: exports.sourceAttribute.hasScau.color },
    uhr7: { name: 'Sedmá úhrada [SCAU]', color: chart_config_1.lineChartColors[14], colorSource: exports.sourceAttribute.hasScau.color },
    uhr8: { name: 'Osmá úhrada [SCAU]', color: chart_config_1.lineChartColors[15], colorSource: exports.sourceAttribute.hasScau.color },
    nhvlpOrc: {
        name: 'Orientační cena [NHVLP]',
        color: chart_config_1.lineChartColors[16],
        colorSource: exports.sourceAttribute.hasNhvlp.color,
    },
    lek13PharmacyPurchasePriceWithoutVatActual: {
        name: 'Nákupní cena bez DPH [LEK-13]',
        color: chart_config_1.lineChartColors[17],
        colorSource: exports.sourceAttribute.hasLek13.color,
    },
    lek13RetailPriceWithVatActual: {
        name: 'Konečná prodejní cena s DPH [LEK-13]',
        color: chart_config_1.lineChartColors[18],
        colorSource: exports.sourceAttribute.hasLek13.color,
    },
};
exports.nameColors = Object.assign.apply(Object, __spreadArray([{}], Object.values(valConfig).map(function (val) {
    var _a;
    return (_a = {}, _a[val.name] = val.colorSource, _a);
}), false));
var mapPriceHistoryDatasets = function (priceHistory) {
    return priceHistory.reduce(function (result, priceRecord) {
        var priceDataSet = result[priceRecord.code] || createPriceDataset(priceRecord.code, priceRecord.color);
        priceDataSet.data.push({
            x: priceRecord.date,
            y: priceRecord.price,
        });
        result[priceRecord.code] = priceDataSet;
        return result;
    }, {});
};
var getRangesFromData = function (points) {
    // Used for drawing timeline slider (overview)
    return {
        start: points.map(function (point) { return new Date(point.month); }).reduce(function (tom, jerry) { return (tom > jerry ? jerry : tom); }),
        end: points.map(function (point) { return new Date(point.month); }).reduce(function (tom, jerry) { return (tom < jerry ? jerry : tom); }),
    };
};
exports.getRangesFromData = getRangesFromData;
var getRangeDataset = function (procedureHistory) {
    return procedureHistory.map(function (proc) { return ({
        name: proc.name,
        sukl: { name: proc.sukls, link: "/search/" + proc.id },
        start: proc.started ? new Date(proc.started) : new Date(),
        end: proc.finished ? new Date(proc.finished) : new Date(),
    }); });
};
exports.getRangeDataset = getRangeDataset;
var createPriceHistoryDatasets = function (rangeData, range) {
    var priceHistory = [];
    var pointsInRange = (0, utils_1.filterPoints)(rangeData, range);
    pointsInRange.forEach(function (point) {
        Object.keys(valConfig).forEach(function (codeT) {
            var code = codeT;
            if (point[code]) {
                priceHistory.push({
                    code: valConfig[code].name,
                    price: Number(point[code]),
                    date: new Date(point.month),
                    color: valConfig[code].color,
                });
            }
        });
    });
    return mapPriceHistoryDatasets(priceHistory);
};
var getVisibleLines = function (chart) {
    var visibleLines = [valConfig.mcv.name, valConfig.exFactory.name, valConfig.mfc.name, valConfig.uhr1.name];
    var series = chart === null || chart === void 0 ? void 0 : chart.series;
    if (series != null) {
        visibleLines = [];
        for (var i = 0; i < series.length; i++) {
            if (series[i].visible) {
                visibleLines.push(series[i].name);
            }
        }
    }
    return visibleLines;
};
var timeChart = function (rangeData, dateFormatter, renderElementId, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var rootElement = document.getElementById(renderElementId);
    var timelineRangeElement = document.createElement('div');
    timelineRangeElement.style.minHeight = '11.5rem'; // minHeight of container has to be set when slider is changing value, to prevent jumping screen between rerenders in FF / Safari
    (_a = rootElement === null || rootElement === void 0 ? void 0 : rootElement.parentElement) === null || _a === void 0 ? void 0 : _a.appendChild(timelineRangeElement);
    var dateRangeElement = document.createElement('div');
    (_b = rootElement === null || rootElement === void 0 ? void 0 : rootElement.parentElement) === null || _b === void 0 ? void 0 : _b.appendChild(dateRangeElement);
    var initialTimelineRange = (0, exports.getRangesFromData)(rangeData.points);
    var begin = new Date(initialTimelineRange.end);
    begin.setMonth(begin.getMonth() - 36);
    // Used for drawing graphs
    var dataDateRange = {
        start: initialTimelineRange.start < begin ? begin : initialTimelineRange.start,
        end: initialTimelineRange.end,
    };
    var state = {
        chart: null,
        range: dataDateRange,
    };
    var drawGraph = function () {
        var _a, _b;
        var defaultVisible = getVisibleLines(state.chart);
        (_a = state.chart) === null || _a === void 0 ? void 0 : _a.destroy();
        var range = state.range;
        var data = createPriceHistoryDatasets(rangeData, range);
        var labels = createLabels(rangeData, range);
        (0, timeline_chart_1.timelineChart)(range, rangeData, data, dateFormatter, labels, timelineRangeElement, __assign(__assign({}, options), { initialRange: initialTimelineRange }));
        var chart = Highcharts.chart({
            chart: {
                renderTo: renderElementId,
                height: 780,
                spacing: [1, 1, 10, 1],
            },
            title: {
                text: 'Ceny a úhrady, distribuce, správní řízení',
                useHTML: true,
                align: 'left',
                margin: 20,
                widthAdjust: -180,
                style: chart_config_1.chartTitleStyleNew,
            },
            subtitle: {
                text: 'Kliknutím na jednotlivé popisky zobrazíte či skryjete danou časovou řadu.',
                //useHTML: true,
                widthAdjust: 0,
                align: 'left',
                style: {
                    color: '#333',
                    fontWeight: '500',
                    fontSize: '12px',
                    lineHeight: '16px',
                    letterSpacing: '0.2px',
                    fontFamily: "'Montserrat', 'system-ui', '-apple-system', 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', 'sans-serif', 'Apple Color Emoji', 'Segoe UI Emoji'",
                    zIndex: 1,
                },
            },
            legend: {
                align: 'left',
                verticalAlign: 'top',
                borderWidth: 0,
                x: -2,
                margin: 5,
                symbolWidth: 8,
                symbolHeight: 8,
                symbolRadius: 4,
                itemMarginBottom: 8,
                useHTML: true,
                itemStyle: {
                    color: '#333',
                    fontWeight: '600',
                    fontSize: '11px',
                    lineHeight: '16px',
                    fontFamily: "'Montserrat', 'system-ui', '-apple-system', 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', 'sans-serif', 'Apple Color Emoji', 'Segoe UI Emoji'",
                },
            },
            series: Object.keys(data).length > 0
                ? Object.values(valConfig)
                    .map(function (item) {
                    return item.name;
                })
                    .filter(function (key) {
                    return data[key];
                })
                    .map(function (code) {
                    var dataset = data[code];
                    return {
                        type: 'line',
                        name: code || '',
                        step: 'center',
                        color: dataset.lineColor,
                        data: labels.map(function (date) {
                            var _a;
                            return (((_a = dataset.data.find(function (_a) {
                                var x = _a.x;
                                var scaleDate = new Date(date.toISOString());
                                var labelDate = new Date(x);
                                return (scaleDate.getMonth() === labelDate.getMonth() &&
                                    scaleDate.getFullYear() === labelDate.getFullYear());
                            })) === null || _a === void 0 ? void 0 : _a.y) || null);
                        }),
                        dataLabels: {
                            enabled: false,
                        },
                        visible: defaultVisible.includes(code),
                    };
                })
                : [{ type: 'line', name: '', data: labels.map(function () { return null; }) }],
            xAxis: {
                tickPixelInterval: 1,
                categories: labels.map(function (date) {
                    try {
                        return dateFormatter(new Date(date));
                    }
                    catch (e) {
                        return String(date);
                    }
                }),
                tickWidth: 0,
                tickLength: 0,
                lineWidth: 0,
                gridLineWidth: 1,
                gridLineColor: '#ccc',
                gridLineDashStyle: 'Dash',
                labels: {
                    align: 'right',
                    x: 0,
                    style: chart_config_1.axisChartLabelFontStyle,
                    rotation: -90,
                },
            },
            yAxis: [
                {
                    // left y axis
                    tickLength: 0,
                    minorTickLength: 0,
                    minorGridLineWidth: 0,
                    gridLineWidth: 1,
                    gridLineColor: '#ccc',
                    gridLineDashStyle: 'Dash',
                    labels: {
                        formatter: function () {
                            return "" + (0, utils_1.formatMoney)(Number(this.value || 0), 0, "" + (typeof options.unit !== 'undefined' ? options.unit : '\u00A0Kč'));
                        },
                        align: 'left',
                        x: 4,
                        y: 16,
                        style: chart_config_1.axisChartLabelFontStyle,
                    },
                    showFirstLabel: false,
                },
                {
                    linkedTo: 0,
                    gridLineWidth: 0,
                    opposite: true,
                    title: {
                        text: null,
                    },
                    labels: {
                        formatter: function () {
                            return "" + (0, utils_1.formatMoney)(Number(this.value || 0), 0, "" + (typeof options.unit !== 'undefined' ? options.unit : '\u00A0Kč'));
                        },
                        align: 'right',
                        x: -4,
                        y: 16,
                        style: chart_config_1.axisChartLabelFontStyle,
                    },
                    showFirstLabel: false,
                },
            ],
            lang: chart_config_1.langConfigCs,
            exporting: (0, chart_config_1.exportingConfig)({
                filename: options.exportFilename,
            }),
            tooltip: {
                shared: true,
                borderRadius: 0,
                borderWidth: 0,
                padding: 0,
                shadow: false,
                useHTML: true,
                borderColor: '#000000',
                backgroundColor: '#FFFFFF',
                formatter: function () {
                    var _a;
                    return "\n\t\t\t\t\t\t<div style=\"background: #fff;padding: 6px 8px 8px 8px;border:1px solid #000;\">\n\t\t\t\t\t\t\t<table cellspacing=\"0\" cellpadding=\"0\" width=\"100%\" class=\"table-timeline-tooltip\">\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<th colspan=\"2\" class=\"tooltip-h2\">" + this.x + "</th>\n\t\t\t\t\t\t\t\t</tr>" + ((_a = this.points) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) {
                        return (b.y || 0) - (a.y || 0);
                    }).reduce(function (string, point) { return string + "<tr><td><i class=\"name-point\" style=\"background: " + point.color + "\"></i><span class=\"name-size-300\">" + point.series.name + "</span>:&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td class=\"td-right\" style=\"text-align: right\"><strong>" + (0, utils_1.formatMoney)(point.y || 0, 0, options.unit) + "</strong></td>\n\t\t\t\t\t\t\t\t</tr>"; }, '')) + "</table></div>";
                },
                valueDecimals: 2,
                style: {
                    color: '#000',
                    fontSize: '12px',
                    fontFamily: chart_config_1.chartFonts,
                },
            },
            plotOptions: {
                series: {
                    lineWidth: 2,
                    step: 'left',
                    marker: {
                        enabledThreshold: 0,
                        symbol: 'circle',
                        radius: 4,
                        states: {
                            hover: {
                                radiusPlus: 2,
                            },
                        },
                    },
                    states: {
                        inactive: {
                            opacity: 1,
                        },
                    },
                },
            },
            credits: {
                enabled: false,
            },
        });
        state.chart = chart;
        (_b = options.onChart) === null || _b === void 0 ? void 0 : _b.call(options, chart);
        return chart;
    };
    var setState = function (createNextState) {
        state = __assign(__assign({}, state), createNextState(state));
        drawGraph();
    };
    (0, date_range_chart_1.createDateRangeChart)(dateRangeElement, initialTimelineRange, (0, exports.getRangeDataset)(rangeData.procedureHistory), options.onDateChange ||
        (function (nextRange) {
            setState(function (prevState) { return (__assign(__assign({}, prevState), { range: nextRange })); });
        }));
    // NOTE: let render the graph for the first time
    setState(function () { return state; });
    return {
        getChart: function () { return state.chart; },
        setState: setState,
    };
};
exports.timeChart = timeChart;
